import React from "react";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setActiveNavbarTab } from "../../../redux-store/slice/activeNavbarSlice";
import Navbar from "../navbar/Navbar";
import PHRAppHeader from "../phr-app-header/PHRAppHeader";
import CampaignManagement from "../campaign-management/CampaignManagement";

const CampaignManagementPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveNavbarTab("campaign_management"));
  }, [dispatch]);

  return (
    <div className="w-full h-screen relative">
      <div className="z-40 relative">
        <PHRAppHeader />
      </div>
      <div className="flex w-full relative pt-14">
        <div className="w-fit fixed z-50 h-screen shadow">
          <Navbar />
        </div>
        <div className="w-[94.8%] ml-auto">
          <CampaignManagement />
        </div>
      </div>
    </div>
  );
};

export default CampaignManagementPage;
